import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__ from "@orbit-ui/core";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import "react";
const containerStyles = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('relative overflow-auto', {
    variants: {
        h: {
            full: 'h-full',
            auto: 'h-auto'
        }
    }
});
const innerStyles = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)('', {
    variants: {
        my: {
            0: '',
            sm: 'my-4',
            md: 'my-12'
        },
        mx: {
            0: '',
            sm: 'container mx-auto max-w-screen-xl px-2 sm:px-4',
            md: 'container mx-auto max-w-screen-xl px-2 sm:px-4'
        }
    }
});
function Container({ mx = 'sm', my = 'sm', h = 'auto', className, children }) {
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
        className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)(containerStyles({
            h
        }), className),
        children: /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)("div", {
            className: (0, __WEBPACK_EXTERNAL_MODULE__orbit_ui_core_b6666371__.cn)(innerStyles({
                mx,
                my
            })),
            children: children
        })
    });
}
export { Container };

//# sourceMappingURL=index.js.map